export const PAYPAL_POS_SALES_CHANNEL_TYPE_ID = '1ce0868f406d47d98cfe4b281e62f099';
export const PAYPAL_POS_SALES_CHANNEL_EXTENSION = 'paypalPosSalesChannel';

export const PAYPAL_AGENTIC_COMMERCE_SALES_CHANNEL_TYPE_ID = 'e3f8c9b2f1a44d4db0f793542e31d2c9';

export default {
    PAYPAL_POS_SALES_CHANNEL_TYPE_ID,
    PAYPAL_POS_SALES_CHANNEL_EXTENSION,
    PAYPAL_AGENTIC_COMMERCE_SALES_CHANNEL_TYPE_ID,
};
